import { buildApiUrl } from '~/app/lib/api-config';
import type { AssetModelMetadata } from '@evimo/types';
import { z } from 'zod';

const assetModelMetadataSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const assetModelMetadataListSchema = z.array(assetModelMetadataSchema);

export const AssetModelService = {
  async findAllByAssetTypeId(
    assetTypeId: string,
  ): Promise<AssetModelMetadata[]> {
    const normalizedAssetTypeId = assetTypeId.trim();

    if (!normalizedAssetTypeId) {
      throw new Error('Asset type id is required');
    }

    const response = await fetch(
      buildApiUrl(`/api/v1/assets/asset-types/${normalizedAssetTypeId}/models`),
      {
        method: 'GET',
        credentials: 'include',
      },
    );

    if (!response.ok) {
      const errorPayload = await response
        .json()
        .catch(() => ({ message: response.statusText }));
      throw new Error(errorPayload.message || 'Failed to fetch asset models');
    }

    return assetModelMetadataListSchema.parse(await response.json());
  },
};
